<template>
  <div class="user-container">
    <top-nav>
      <a @click="doLogout">退出</a>
    </top-nav>
    <div class="container">
      <div class="panel">
        <h1>我的信息</h1>
        <div class="context">
          <ul>
            <li>
              <label class="title">头&nbsp;&nbsp;像</label>
              <label class="value">
                <img style="vertical-align:middle;" :src="headerImageSrc" class="header" />
              </label>
            </li>
            <li>
              <label class="title">昵&nbsp;&nbsp;&nbsp;&nbsp;称</label>
              <label class="value">{{userInfo.nick ? userInfo.nick : '-' }}</label>
            </li>
            <li>
              <label class="title">账&nbsp;&nbsp;&nbsp;&nbsp;号</label>
              <label class="value">{{userInfo.userName ? userInfo.userName : '-' }}</label>
            </li>
            <li>
              <label class="title">手机号</label>
              <label class="value">{{userInfo.phone}}</label>
            </li>
            <li>
              <label class="title">邮&nbsp;&nbsp;&nbsp;&nbsp;箱</label>
              <label
                class="value"
              >{{userInfo.email ? userInfo.email + '(' + userInfo.emailCheckName + ")" : '-' }}</label>
            </li>
          </ul>
        </div>
      </div>
      <div class="panel">
        <h1>我的授权</h1>
        <div class="context" style="padding:0 20px 20px 20px;">
          <div v-if="false" class="certy">
            <div class="certy-item">
              <div>
                <div class="left">
                  <svg-icon
                    iconClass="star"
                    class="certy-icon"
                    :class="{'a-icon': userInfo.idfiStatus === '30'}"
                  />
                  <div class="left-text" :class="{'a-text': userInfo.idfiStatus === '30'}">个人权限</div>
                </div>
                <div class="right">
                  <div v-if="userInfo.idfiStatus === '30'" class="right-info">
                    认证时间:
                    <br />
                    {{userInfo.idfiTime}}
                  </div>
                  <div v-else class="right-info">{{userInfo.idfiStatusName}}</div>
                  <div class="right-button-div">
                    <span class="right-button">{{userInfo.idfiStatus === '10'? '' : ''}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="certy-item">
              <div>
                <div class="left">
                  <svg-icon iconClass="star" class="certy-icon" />
                  <div class="left-text">企业权限</div>
                </div>
                <div class="right">
                  <div class="right-info">未认证</div>
                  <div v-if="false" class="right-button-div">
                    <span class="right-button">企业认证</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <table class="history" cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th>授权应用</th>
                <th>授权权限</th>
                <th>到期时间</th>
                <th>授权原因</th>
                <th>授权时间</th>
              </tr>
            </thead>
            <tbody v-if="grantInfo.length > 0">
              <tr v-for="(item, index) in grantInfo" :key="index">
                <td
                  v-if="index === 0 ||
                  item.appName !== grantInfo[index-1].appName"
                  :rowspan="getRowSpan(item, index, 'appName')"
                >
                  <a
                    v-if="item.adminUrl"
                    class="link"
                    :href="item.adminUrl"
                    target="_self"
                  >{{item.appName}}</a>
                  <span v-else>{{item.appName}}</span>
                </td>
                <td>{{item.roleName}}</td>
                <td>{{item.expireTime === '2099-12-31'? '永久': item.expireTime}}</td>
                <td>{{item.reason}}</td>
                <td>{{item.authTime}}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="noData" colspan="5">还没有任何权限~</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopNav from "../components/TopNav.vue";
import Footer from "../components/Footer.vue";

import { loginOut, getLoginUser, getDocImage, userAllRoles } from "@/api/login";
import { removeLogin } from "@/utils/auth";

export default {
  name: "register",
  components: {
    TopNav,
    Footer
  },
  props: {
    msg: String
  },
  data() {
    return {
      userInfo: {},
      grantInfo: []
    };
  },

  computed: {
    headerImageSrc() {
      if (this.userInfo.headDocId) {
        return getDocImage(this.userInfo.headDocId);
      } else {
        return "login.jpg";
      }
    }
  },
  created() {
    this.initUserInfo();
  },
  destroyed() {},

  watch: {},

  methods: {
    getRowSpan(item, index, colName) {
      if (index > 0 && item[colName] === this.grantInfo[index - 1][colName]) {
        return 0;
      }
      let count = 1;
      for (var i = index + 1; i < this.grantInfo.length; i++) {
        if (item[colName] === this.grantInfo[i][colName]) {
          count++;
        } else {
          break;
        }
      }
      return count;
    },
    initUserInfo() {
      getLoginUser().then(res => {
        if (res.success) {
          this.userInfo = res.data;
        }
      });
      userAllRoles().then(res => {
        if (res.success) {
          let temp = [];
          res.data.forEach(item => {
            item.roles.forEach(role => {
              if (role.relType === "100") {
                let row = {
                  appName: item.appName,
                  appCd: item.appCd,
                  adminUrl: item.adminUrl
                };
                row.roleName = role.roleName;
                row.expireTime = role.expireTime;
                row.authTime = role.authTime;
                row.reason = role.reason;
                temp.push(row);
              }
            });
          });
          this.grantInfo = temp;
        }
      });
    },
    doLogout() {
      loginOut()
        .then(res => {
          if (res.success) {
            removeLogin();
            this.$router.push({ path: "/", query: {} });
          } else {
            alert(res.msg);
          }
        })
        .catch(err => {
          console.error("log out error", err);
        });
    },
    getAppUrl(appCd) {
      appCd = appCd.toUpperCase();
      if (appCd === "URMP") {
        let adminUrl = process.env.VUE_APP_URMP_ADMIN;
        return adminUrl;
      } else if (appCd === "DSTAGE") {
        let adminUrl = process.env.VUE_APP_DSTAGE_ADMIN;
        return adminUrl;
      } else if (appCd === "DAQ") {
        let adminUrl = process.env.VUE_APP_DAQ_ADMIN;
        return adminUrl;
      } else if (appCd === "XXL-JOB") {
        let adminUrl = process.env.VUE_APP_XXL_ADMIN;
        return adminUrl;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.user-container {
  background-color: #f5f1f1;
  padding-bottom: 60px;
}

.panel {
  background: white;
  margin: 20px;
  padding: 20px;
}

.panel h1 {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  padding-bottom: 10px;
  padding-left: 10px;
  border-bottom: 1px solid #dddddd;
}

.panel .context {
  min-height: 150px;
  text-align: left;
  padding: 20px 40px;
}

ul li {
  list-style: none;
  line-height: 50px;
}

label.title,
label.value {
  display: inline-block;
  font-size: 14px;
}

label.title {
  text-align: center;
  width: 120px;
}

.header {
  width: 100px;
  height: 100px;
  border-radius: 50px;
}

.certy-item {
  height: 160px;
  width: 50%;
  display: inline-block;
  vertical-align: top;
}

.certy-item > div {
  height: 100%;
  margin: 10px 20px;
  border: 1px solid #dddddd;
}

div.left {
  float: left;
  width: 100px;
  text-align: center;
}
.left-text {
  color: #c5c1c1;
}
.certy-icon {
  font-size: 80px;
  margin-top: 30px;
  fill: #c5c1c1 !important;
}

.a-icon {
  fill: #0c9af4 !important;
}
.a-text {
  color: #0c9af4 !important;
}
div.right {
  margin-left: 120px;
}

.right-info {
  padding-top: 20px;
  height: 100px;
  font-size: 14px;
  line-height: 200%;
}
.right-button-div {
  height: 35px;
}
.right-button {
  margin-left: 20px;
  display: inline-block;
  width: 120px;
  line-height: 35px;
  border-radius: 35px;
  background-color: #0c9af4;
  text-align: center;
  color: white;
  cursor: default;
  user-select: none;
}

.history {
  margin-top: 40px;
  width: 100%;
}
.history thead tr th {
  line-height: 40px;
  background-color: #e0f4ff;
  padding: 0 10px;
}
.history tbody tr td {
  padding: 10px 10px 0 10px;
  line-height: 40px;
  border-bottom: 1px solid #dddddd;
}

.link {
  text-decoration: underline;
  cursor: pointer;
  color: #0c9af4;
}
.noData {
  line-height: 200px;
  text-align: center;
}

@media only screen and (min-width: 992px) {
  .container {
    width: 970px;
    margin: 0 auto;
  }
}
</style>
